import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./DeliveryApplicationSubmitted.css";

function DeliveryApplicationSubmitted() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [application, setApplication] = useState({

        status: "Pending",

        rejectionReason: ""

    });

    useEffect(() => {

        fetchStatus();

    }, []);

    const fetchStatus = async () => {

        try {

            const response = await API.get(

                "/delivery/application/status"

            );

            if (response.data.success) {

                setApplication(

                    response.data.application

                );

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    const handleLogin = () => {

        navigate("/login");

    };

    if (loading) {

        return (

            <div className="delivery-submitted-page">

                <h2>Loading...</h2>

            </div>

        );

    }

    return (

        <div className="delivery-submitted-page">

            <div className="delivery-submitted-card">

                <div className="success-icon">

                    {application.status === "Approved"
                        ? "🎉"
                        : application.status === "Rejected"
                        ? "❌"
                        : "📄"}

                </div>

                <h1>

                    HomeFoods

                </h1>

                <h2>

                    Application Status

                </h2>

                {/* ==========================
                    Pending
                ========================== */}

                {

                    application.status === "Pending" && (

                        <>

                            <p className="description">

                                Your application has been submitted successfully.

                                <br /><br />

                                Our HomeFoods team is reviewing your application.

                            </p>

                            <div className="status-card">

                                <h3>

                                    Current Status

                                </h3>

                                <div className="status pending">

                                    🟡 Pending Verification

                                </div>

                            </div>

                            <div className="verification-list">

                                <h3>

                                    Our Team Will Verify

                                </h3>

                                <ul>

                                    <li>✅ Personal Information</li>

                                    <li>✅ Vehicle Details</li>

                                    <li>✅ Documents</li>

                                    <li>✅ Bank Details</li>

                                </ul>

                            </div>

                            <div className="info-box">

                                📧 You will receive an email once your application is approved.

                            </div>

                        </>

                    )

                }

                {/* ==========================
                    Approved
                ========================== */}

                {

                    application.status === "Approved" && (

                        <>

                            <p className="description">

                                🎉 Congratulations!

                                <br /><br />

                                Your HomeFoods Delivery Partner application has been approved.

                                <br /><br />

                                You can now log in using your registered email and password.

                            </p>

                            <div className="status-card">

                                <h3>

                                    Current Status

                                </h3>

                                <div className="status approved">

                                    🟢 Approved

                                </div>

                            </div>

                            <button

                                className="login-btn"

                                onClick={handleLogin}

                            >

                                Go To Login

                            </button>

                        </>

                    )

                }

                {/* ==========================
                    Rejected
                ========================== */}

                {

                    application.status === "Rejected" && (

                        <>

                            <p className="description">

                                Unfortunately your application could not be approved.

                            </p>

                            <div className="status-card">

                                <h3>

                                    Current Status

                                </h3>

                                <div className="status rejected">

                                    🔴 Rejected

                                </div>

                            </div>

                            <div className="info-box">

                                <strong>Reason:</strong>

                                <br />

                                {

                                    application.rejectionReason ||

                                    "No reason provided."

                                }

                            </div>

                        </>

                    )

                }

            </div>

        </div>

    );

}

export default DeliveryApplicationSubmitted;